export default __webpack_public_path__ + "assets/webgl/wave-map.c6ca017e.jpg";